import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { FeeBudgetRuleDto } from '@/models/fee-budgets/FeeBudgetRuleDto';
import { LoadOptions } from 'devextreme/data/load_options';

export class FeeBudgetRuleService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/feebudgetrules');
  }

  async list(options: LoadOptions): Promise<any> {
    return await this.client.getPostData('/list', options);
  }

  async get(id: Guid): Promise<FeeBudgetRuleDto> {
    return await this.client.get<FeeBudgetRuleDto>(`/${id}`);
  }

  async create(data: FeeBudgetRuleDto): Promise<FeeBudgetRuleDto> {
    return await this.client.getPostData<FeeBudgetRuleDto>('', data);
  }

  async update(id: Guid, data: FeeBudgetRuleDto): Promise<FeeBudgetRuleDto> {
    return await this.client.getData<FeeBudgetRuleDto>(HttpMethodEnum.Put, `/${id}`, data);
  }

  async delete(id: Guid): Promise<FeeBudgetRuleDto> {
    return await this.client.getData<FeeBudgetRuleDto>(HttpMethodEnum.Delete, `/${id}`);
  }
}
